import { KEYS } from './keys';

const ro = {
    [KEYS.COMMON_EMAIL]: 'Email',
    [KEYS.COMMON_PASSWORD]: 'Parolă',
    [KEYS.COMMON_NAME]: 'Nume',
    [KEYS.COMMON_BACK]: 'Înapoi',
    [KEYS.COMMON_LOADING]: 'Se încarcă...',
    [KEYS.COMMON_BACK_TO_LOGIN]: 'Înapoi la autentificare',
    [KEYS.COMMON_ERROR_GENERIC]: 'Ceva nu a mers bine. Te rugăm să încerci din nou.',
    [KEYS.COMMON_NEVER]: 'Niciodată',
    [KEYS.COMMON_CANCEL]: 'Anulează',
    [KEYS.COMMON_SAVE]: 'Salvează',
    [KEYS.COMMON_CLOSE]: 'Închide',
    [KEYS.COMMON_CONFIRM]: 'Confirmă',
    [KEYS.COMMON_DELETE]: 'Șterge',
    [KEYS.COMMON_EDIT]: 'Editează',
    [KEYS.COMMON_ADD]: 'Adaugă',
    [KEYS.COMMON_RETRY]: 'Încearcă din nou',
    [KEYS.COMMON_VIEW]: 'Vizualizează',
    [KEYS.COMMON_RESET]: 'Resetează',
    [KEYS.COMMON_YES]: 'Da',
    [KEYS.COMMON_NO]: 'Nu',
    [KEYS.COMMON_DESCRIPTION]: 'Descriere',
    [KEYS.COMMON_PHONE]: 'Telefon',
    [KEYS.COMMON_WEBSITE]: 'Site web',
    [KEYS.COMMON_NOTES]: 'Note',
    [KEYS.COMMON_STATUS]: 'Status',
    [KEYS.COMMON_DETAILS]: 'Detalii',
    [KEYS.COMMON_LABEL]: 'Etichetă',
    [KEYS.COMMON_VALUE]: 'Valoare',
    [KEYS.COMMON_UNIT]: 'Unitate',
    [KEYS.COMMON_TYPE]: 'Tip',
    [KEYS.COMMON_SERVICE]: 'Serviciu',
    [KEYS.COMMON_SUPPLIER]: 'Furnizor',
    [KEYS.COMMON_FREQUENCY]: 'Frecvență',
    [KEYS.COMMON_TITLE]: 'Titlu',
    [KEYS.COMMON_AMOUNT]: 'Sumă',
    [KEYS.COMMON_CREATING]: 'Se creează...',
    [KEYS.COMMON_SAVING]: 'Se salvează...',
    [KEYS.COMMON_DELETING]: 'Se șterge...',
    [KEYS.COMMON_UPDATING]: 'Se actualizează...',
    [KEYS.COMMON_GENERATING]: 'Se generează...',
    [KEYS.COMMON_ADDING]: 'Se adaugă...',
    [KEYS.COMMON_SAVE_CHANGES]: 'Salvează modificările',
    [KEYS.COMMON_CANNOT_UNDO]: 'Această acțiune nu poate fi anulată',
    [KEYS.COMMON_DONE]: 'Gata',
    [KEYS.COMMON_COPY]: 'Copiază',
    [KEYS.COMMON_COPIED]: 'Copiat',
    [KEYS.COMMON_ERROR_MAX_CHARS]: 'Maximum 191 caractere',
    [KEYS.COMMON_ERROR_INVALID_EMAIL]: 'Format email invalid',
    [KEYS.COMMON_ERROR_INVALID_URL]: 'Format URL invalid',
    [KEYS.COMMON_DATE_ISSUED]: 'Dată emitere',
    [KEYS.COMMON_DATE_DUE]: 'Dată scadentă',
    [KEYS.COMMON_DATE_PAID]: 'Dată plată',
    [KEYS.COMMON_MARK_AS_PAID]: 'Marchează ca plătit',
    [KEYS.COMMON_MARK_AS_READ]: 'Marchează ca citit',
    [KEYS.COMMON_LOAD_MORE]: 'Încarcă mai mult',
    [KEYS.COMMON_UNKNOWN_SERVICE]: 'Serviciu necunoscut',
    [KEYS.COMMON_CREATED_BY]: 'Creată de',
    [KEYS.COMMON_ACTIONS]: 'Acțiuni',
    [KEYS.COMMON_OPTIONAL]: 'opțional',

    [KEYS.TYPE_ELECTRICITY]: 'Electricitate',
    [KEYS.TYPE_NATURAL_GAS]: 'Gaz natural',
    [KEYS.TYPE_WATER]: 'Apă',
    [KEYS.TYPE_PHONE]: 'Telefon',
    [KEYS.TYPE_INTERNET]: 'Internet',
    [KEYS.TYPE_OTHER]: 'Altul',

    [KEYS.EMPTY_SUPPLIERS_TITLE]: 'Niciun furnizor încă',
    [KEYS.EMPTY_SUPPLIERS_DESCRIPTION]: 'Adaugă primul furnizor pentru a începe monitorizarea.',
    [KEYS.EMPTY_SUPPLIERS_ACTION]: 'Adaugă furnizor',
    [KEYS.EMPTY_SERVICES_TITLE]: 'Niciun serviciu găsit',
    [KEYS.EMPTY_SERVICES_DESCRIPTION]: 'Adaugă un serviciu pentru a urmări facturile.',
    [KEYS.EMPTY_SERVICES_ACTION]: 'Adaugă serviciu',
    [KEYS.EMPTY_INVOICES_TITLE]: 'Nicio factură găsită',
    [KEYS.EMPTY_INVOICES_DESCRIPTION]: 'Începe monitorizarea adăugând o factură.',
    [KEYS.EMPTY_INVOICES_ACTION]: 'Adaugă factură',
    [KEYS.EMPTY_READINGS_TITLE]: 'Nicio citire găsită',
    [KEYS.EMPTY_READINGS_DESCRIPTION]: 'Începe monitorizarea adăugând o citire de contor.',
    [KEYS.EMPTY_READINGS_ACTION]: 'Adaugă citire',
    [KEYS.EMPTY_CREDENTIALS_TITLE]: 'Nicio credențială încă',
    [KEYS.EMPTY_CREDENTIALS_DESCRIPTION]: 'Salvează în siguranță datele de autentificare.',
    [KEYS.EMPTY_CREDENTIALS_ACTION]: 'Adaugă credențială',
    [KEYS.EMPTY_REMINDERS_TITLE]: 'Niciun memento încă',
    [KEYS.EMPTY_REMINDERS_DESCRIPTION]: 'Adaugă un memento pentru a nu uita termenele.',
    [KEYS.EMPTY_REMINDERS_ACTION]: 'Adaugă memento',
    [KEYS.EMPTY_SEARCH_TITLE]: 'Niciun rezultat găsit',
    [KEYS.EMPTY_SEARCH_DESCRIPTION]: 'Nimic nu corespunde cu "{query}".',
    [KEYS.EMPTY_SEARCH_DESCRIPTION_GENERIC]: 'Încearcă să ajustezi căutarea.',
    [KEYS.EMPTY_ERROR_TITLE]: 'Ceva nu a mers bine',
    [KEYS.EMPTY_ERROR_DESCRIPTION]: 'A apărut o eroare. Te rugăm să încerci din nou.',

    [KEYS.LOGIN_TAGLINE]: 'Autentifică-te în contul tău',
    [KEYS.LOGIN_FORGOT_PASSWORD]: 'Ai uitat parola?',
    [KEYS.LOGIN_SUBMIT]: 'Autentificare',
    [KEYS.LOGIN_SUBMITTING]: 'Se autentifică...',
    [KEYS.LOGIN_NO_ACCOUNT]: 'Nu ai un cont?',
    [KEYS.LOGIN_CREATE_ONE]: 'Creează unul',
    [KEYS.LOGIN_RESET_SUCCESS]: 'Parola ta a fost resetată. Autentifică-te mai jos.',
    [KEYS.LOGIN_ERROR_GENERIC]: 'A apărut o eroare la autentificare',    
    [KEYS.LOGIN_REMEMBER_ME]: 'Ține-mă minte',
    [KEYS.REGISTER_TAGLINE_INVITE]: 'Introdu codul de invitație',
    [KEYS.REGISTER_TAGLINE_FORM]: 'Creează-ți contul',
    [KEYS.REGISTER_INVITE_CODE]: 'Cod de invitație',
    [KEYS.REGISTER_INVITE_PLACEHOLDER]: 'Lipește codul de invitație aici',
    [KEYS.REGISTER_CONTINUE]: 'Continuă',
    [KEYS.REGISTER_CONTINUING]: 'Se verifică...',
    [KEYS.REGISTER_CONFIRM_PASSWORD]: 'Confirmă parola',
    [KEYS.REGISTER_SUBMIT]: 'Creează cont',
    [KEYS.REGISTER_SUBMITTING]: 'Se creează contul...',
    [KEYS.REGISTER_ALREADY_ACCOUNT]: 'Ai deja un cont?',
    [KEYS.REGISTER_SIGN_IN]: 'Autentifică-te',
    [KEYS.REGISTER_ERROR_INVITE_REQUIRED]: 'Te rugăm să introduci un cod de invitație',
    [KEYS.REGISTER_ERROR_PASSWORDS_MISMATCH]: 'Parolele nu coincid',
    [KEYS.REGISTER_ERROR_GENERIC]: 'A apărut o eroare la înregistrare',

    [KEYS.HOME_TITLE]: 'Panou principal',
    [KEYS.HOME_SUBTITLE]: 'Privire de ansamblu asupra facturilor și serviciilor',
    [KEYS.HOME_STAT_TOTAL_SERVICES]: 'Total servicii',
    [KEYS.HOME_STAT_MONTHLY_SPEND]: 'Cheltuieli lunare',
    [KEYS.HOME_STAT_SUPPLIERS]: 'Furnizori',
    [KEYS.HOME_STAT_SERVICE_TYPES]: 'Tipuri de servicii',
    [KEYS.HOME_UPCOMING_DUE]: 'Scadente în curând',
    [KEYS.HOME_OUTSTANDING_BY_CATEGORY]: 'Restanțe pe categorie',
    [KEYS.HOME_NO_UPCOMING_INVOICES]: 'Nicio factură scadentă',
    [KEYS.HOME_NO_OUTSTANDING_INVOICES]: 'Nicio factură restantă',
    [KEYS.HOME_ERROR_LOAD]: 'Eroare la încărcarea datelor',

    [KEYS.SUPPLIERS_TITLE]: 'Furnizori',
    [KEYS.SUPPLIERS_SUBTITLE]: 'Gestionează furnizorii de servicii',
    [KEYS.SUPPLIERS_ADD]: 'Adaugă furnizor',
    [KEYS.SUPPLIERS_ERROR_LOAD]: 'Eroare la încărcarea furnizorilor',
    [KEYS.SUPPLIERS_NOT_FOUND]: 'Furnizorul nu a fost găsit',
    [KEYS.SUPPLIERS_BACK]: 'Înapoi la furnizori',

    [KEYS.SERVICES_TITLE]: 'Servicii',
    [KEYS.SERVICES_SUBTITLE]: 'Toate serviciile urmărite pe categorii',
    [KEYS.SERVICES_ERROR_LOAD]: 'Eroare la încărcarea serviciilor',
    [KEYS.SERVICES_NOT_FOUND]: 'Serviciul nu a fost găsit',
    [KEYS.SERVICES_BACK]: 'Înapoi la servicii',
    [KEYS.SERVICES_ADD]: 'Adaugă serviciu',

    [KEYS.SERVICE_DETAIL_EDIT]: 'Editează',
    [KEYS.SERVICE_DETAIL_DETAILS]: 'Detalii',
    [KEYS.SERVICE_DETAIL_TYPE]: 'Tip',
    [KEYS.SERVICE_DETAIL_SUPPLIER]: 'Furnizor',
    [KEYS.SERVICE_DETAIL_DESCRIPTION]: 'Descriere',
    [KEYS.SERVICE_DETAIL_NAV_READINGS]: 'Citiri',
    [KEYS.SERVICE_DETAIL_NAV_READINGS_SUB]: 'Valori contor și consum',
    [KEYS.SERVICE_DETAIL_NAV_INVOICES]: 'Facturi',
    [KEYS.SERVICE_DETAIL_NAV_INVOICES_SUB]: 'Facturi și urmărire plăți',
    [KEYS.SERVICE_DETAIL_NAV_READING_TEMPLATES]: 'Șabloane citiri',
    [KEYS.SERVICE_DETAIL_NAV_READING_TEMPLATES_SUB]: 'Presetări reutilizabile pentru citiri',
    [KEYS.SERVICE_DETAIL_NAV_INVOICE_TEMPLATES]: 'Șabloane facturi',
    [KEYS.SERVICE_DETAIL_NAV_INVOICE_TEMPLATES_SUB]: 'Modele reutilizabile de facturi',
    [KEYS.SERVICE_DETAIL_NAV_ACTIONS]: 'Acțiuni programate',
    [KEYS.SERVICE_DETAIL_NAV_ACTIONS_SUB]: 'Reguli de creare automată',
    [KEYS.SERVICE_DETAIL_INVOICE_HISTORY]: 'Istoric facturi',

    [KEYS.SERVICE_READINGS_TITLE]: 'Citiri',
    [KEYS.SERVICE_READINGS_ADD]: 'Adaugă citire',
    [KEYS.SERVICE_READINGS_ERROR_LOAD]: 'Eroare la încărcarea citirilor',
    [KEYS.SERVICE_READINGS_COL_VALUE]: 'Valoare',
    [KEYS.SERVICE_READINGS_COL_UNIT]: 'Unitate',
    [KEYS.SERVICE_READINGS_COL_READ_DATE]: 'Data citirii',
    [KEYS.SERVICE_READINGS_COL_NOTES]: 'Note',

    [KEYS.SERVICE_INVOICES_TITLE]: 'Facturi',
    [KEYS.SERVICE_INVOICES_ADD]: 'Adaugă factură',
    [KEYS.SERVICE_INVOICES_ERROR_LOAD]: 'Eroare la încărcarea facturilor',

    [KEYS.SERVICE_INVOICE_TEMPLATES_TITLE]: 'Șabloane facturi',
    [KEYS.SERVICE_INVOICE_TEMPLATES_ADD]: 'Adaugă șablon',
    [KEYS.SERVICE_INVOICE_TEMPLATES_ERROR_LOAD]: 'Eroare la încărcarea șabloanelor de facturi',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_LABEL]: 'Etichetă',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_NAME]: 'Nume',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_AMOUNT]: 'Sumă',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_ISSUE_DATE]: 'Dată emitere',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_DUE_DATE]: 'Dată scadentă',
    [KEYS.SERVICE_INVOICE_TEMPLATES_EMPTY]: 'Niciun șablon de factură încă. Creează un model reutilizabil pentru acest serviciu.',

    [KEYS.SERVICE_READING_TEMPLATES_TITLE]: 'Șabloane citiri',
    [KEYS.SERVICE_READING_TEMPLATES_ADD]: 'Adaugă șablon',
    [KEYS.SERVICE_READING_TEMPLATES_ERROR_LOAD]: 'Eroare la încărcarea șabloanelor de citiri',
    [KEYS.SERVICE_READING_TEMPLATES_COL_LABEL]: 'Etichetă',
    [KEYS.SERVICE_READING_TEMPLATES_EMPTY]: 'Niciun șablon de citire încă. Creează o presetare reutilizabilă pentru acest serviciu.',

    [KEYS.SERVICE_ACTIONS_TITLE]: 'Acțiuni programate',
    [KEYS.SERVICE_ACTIONS_ADD]: 'Adaugă acțiune',
    [KEYS.SERVICE_ACTIONS_ERROR_LOAD]: 'Eroare la încărcarea acțiunilor programate',
    [KEYS.SERVICE_ACTIONS_COL_TYPE]: 'Tip',
    [KEYS.SERVICE_ACTIONS_COL_FREQUENCY]: 'Frecvență',
    [KEYS.SERVICE_ACTIONS_COL_NEXT_RUN]: 'Următoare rulare',
    [KEYS.SERVICE_ACTIONS_COL_LAST_RUN]: 'Ultima rulare',
    [KEYS.SERVICE_ACTIONS_COL_ACTIVE]: 'Activ',
    [KEYS.SERVICE_ACTIONS_EMPTY]: 'Nicio acțiune programată. Configurează automatizarea pentru a crea facturi sau citiri periodic.',
    [KEYS.SERVICE_ACTIONS_TYPE_CREATE_INVOICE]: 'Creare factură',
    [KEYS.SERVICE_ACTIONS_TYPE_CREATE_READING]: 'Creare citire',
    [KEYS.SERVICE_ACTIONS_FREQ_ONCE]: 'O dată',
    [KEYS.SERVICE_ACTIONS_FREQ_DAILY]: 'Zilnic',
    [KEYS.SERVICE_ACTIONS_FREQ_WEEKLY]: 'Săptămânal',
    [KEYS.SERVICE_ACTIONS_FREQ_MONTHLY]: 'Lunar',
    [KEYS.SERVICE_ACTIONS_FREQ_YEARLY]: 'Anual',

    [KEYS.INVOICES_TITLE]: 'Facturi',
    [KEYS.INVOICES_SUBTITLE]: 'Urmărește și gestionează facturile',
    [KEYS.INVOICES_ADD]: 'Adaugă factură',
    [KEYS.INVOICES_ERROR_LOAD]: 'Eroare la încărcarea facturilor',
    [KEYS.INVOICES_COL_NAME]: 'Nume',
    [KEYS.INVOICES_COL_SERVICE]: 'Serviciu',
    [KEYS.INVOICES_COL_ISSUED]: 'Emisă',
    [KEYS.INVOICES_COL_DUE]: 'Scadentă',
    [KEYS.INVOICES_COL_AMOUNT]: 'Sumă',
    [KEYS.INVOICES_COL_STATUS]: 'Status',
    [KEYS.INVOICES_FILTER_ALL]: 'Toate statusurile',
    [KEYS.INVOICES_FILTER_UNPAID]: 'Neplătite',
    [KEYS.INVOICES_FILTER_PAID]: 'Plătite',
    [KEYS.INVOICES_FILTER_OVERDUE]: 'Restante',
    [KEYS.INVOICES_RESET_FILTERS]: 'Resetează',
    [KEYS.INVOICES_STATUS_PAID]: 'plătită',
    [KEYS.INVOICES_STATUS_PENDING]: 'în așteptare',
    [KEYS.INVOICES_STATUS_OVERDUE]: 'restantă',
    [KEYS.INVOICES_STATUS_UPCOMING]: 'viitoare',
    [KEYS.INVOICES_LOAD_MORE]: 'Încarcă mai mult',
    [KEYS.INVOICES_LOADING_MORE]: 'Se încarcă...',
    [KEYS.CREATED_BY_USER]: 'Manual',
    [KEYS.CREATED_BY_AUTOMATION]: 'Automat',
    [KEYS.CREATED_BY_SCHEDULE]: 'Programat',
    [KEYS.CREATED_BY_UNKNOWN]: 'Necunoscut',

    [KEYS.REMINDERS_TITLE]: 'Memento-uri',
    [KEYS.REMINDERS_SUBTITLE]: 'Fii la curent cu sarcinile recurente și termenele',
    [KEYS.REMINDERS_ADD]: 'Adaugă memento',
    [KEYS.REMINDERS_ERROR_LOAD]: 'Eroare la încărcarea memento-urilor',
    [KEYS.REMINDERS_COL_TITLE]: 'Titlu',
    [KEYS.REMINDERS_COL_DUE_DATE]: 'Dată scadentă',
    [KEYS.REMINDERS_COL_FREQUENCY]: 'Frecvență',
    [KEYS.REMINDERS_COL_STATUS]: 'Status',
    [KEYS.REMINDERS_STATUS_OVERDUE]: 'restant',
    [KEYS.REMINDERS_STATUS_ACTIVE]: 'activ',
    [KEYS.REMINDERS_STATUS_INACTIVE]: 'inactiv',
    [KEYS.REMINDERS_FREQ_QUARTERLY]: 'Trimestrial',

    [KEYS.PROFILE_EMAIL]: 'Email',
    [KEYS.PROFILE_MEMBER_SINCE]: 'Membru din',
    [KEYS.PROFILE_EDIT]: 'Editează profilul',
    [KEYS.PROFILE_DELETE]: 'Șterge contul',
    [KEYS.PROFILE_INTEGRATIONS]: 'Integrări',
    [KEYS.PROFILE_API_KEYS_LABEL]: 'Chei API',
    [KEYS.PROFILE_API_KEYS_DESCRIPTION]: 'Gestionează tokenurile de acces pentru integrări externe',
    [KEYS.PROFILE_INVITE_CODES_LABEL]: 'Coduri de invitație',
    [KEYS.PROFILE_INVITE_CODES_DESCRIPTION]: 'Generează coduri de unică folosință pentru a invita utilizatori noi',
    [KEYS.PROFILE_ERROR_LOAD]: 'Eroare la încărcarea datelor profilului',
    [KEYS.PROFILE_UPDATE_SUCCESS]: 'Profilul a fost actualizat cu succes',
    [KEYS.PROFILE_PREFERENCES]: 'Preferințe',
    [KEYS.PROFILE_CURRENCY]: 'Simbol Monedă',

    [KEYS.API_KEYS_TITLE]: 'Chei API',
    [KEYS.API_KEYS_SUBTITLE]: 'Gestionează tokenuri de lungă durată pentru integrări și scripturi externe',
    [KEYS.API_KEYS_ADD]: 'Adaugă cheie API',
    [KEYS.API_KEYS_ERROR_LOAD]: 'Eroare la încărcarea cheilor API',
    [KEYS.API_KEYS_COL_NAME]: 'Nume',
    [KEYS.API_KEYS_COL_ABILITIES]: 'Permisiuni',
    [KEYS.API_KEYS_COL_LAST_USED]: 'Ultima utilizare',
    [KEYS.API_KEYS_COL_EXPIRES]: 'Expiră',
    [KEYS.API_KEYS_FULL_ACCESS]: 'Acces complet',
    [KEYS.API_KEYS_SCOPES_SINGULAR]: '{n} permisiune',
    [KEYS.API_KEYS_SCOPES_PLURAL]: '{n} permisiuni',
    [KEYS.API_KEYS_EMPTY_TITLE]: 'Nicio cheie API încă',
    [KEYS.API_KEYS_EMPTY_DESCRIPTION]: 'Creează o cheie pentru a permite aplicațiilor externe să acționeze în numele tău',

    [KEYS.INVITE_CODES_TITLE]: 'Coduri de invitație',
    [KEYS.INVITE_CODES_SUBTITLE]: 'Generează coduri de unică folosință pentru a invita utilizatori noi',
    [KEYS.INVITE_CODES_GENERATE]: 'Generează cod',
    [KEYS.INVITE_CODES_GENERATING]: 'Se generează...',
    [KEYS.INVITE_CODES_ERROR_LOAD]: 'Eroare la încărcarea codurilor de invitație',
    [KEYS.INVITE_CODES_COL_CODE]: 'Cod',
    [KEYS.INVITE_CODES_COL_STATUS]: 'Status',
    [KEYS.INVITE_CODES_COL_USED]: 'Utilizat',
    [KEYS.INVITE_CODES_COL_CREATED]: 'Creat',
    [KEYS.INVITE_CODES_STATUS_USED]: 'Utilizat',
    [KEYS.INVITE_CODES_STATUS_UNUSED]: 'Neutilizat',
    [KEYS.INVITE_CODES_EMPTY_TITLE]: 'Niciun cod de invitație încă',
    [KEYS.INVITE_CODES_EMPTY_DESCRIPTION]: 'Generează un cod pentru a invita pe cineva să-și creeze un cont',

    [KEYS.NOTIFICATIONS_TITLE]: 'Notificări',
    [KEYS.NOTIFICATIONS_SUBTITLE]: 'Memento-uri, facturi restante și plăți viitoare',
    [KEYS.NOTIFICATIONS_MARK_ALL_READ]: 'Marchează toate ca citite',
    [KEYS.NOTIFICATIONS_MARK_READ]: 'Marchează ca citit',
    [KEYS.NOTIFICATIONS_EMPTY]: 'Ești la zi cu tot!',
    [KEYS.NOTIFICATIONS_PUSH_TITLE]: 'Notificări push',
    [KEYS.NOTIFICATIONS_PUSH_DESCRIPTION]: 'Primește notificări despre facturi restante și memento-uri scadente chiar și când aplicația este închisă.',
    [KEYS.NOTIFICATIONS_PUSH_ENABLE]: 'Activează notificările',
    [KEYS.NOTIFICATIONS_PUSH_DISABLE]: 'Dezactivează notificările',
    [KEYS.NOTIFICATIONS_PUSH_NOT_SUPPORTED]: 'Notificările push nu sunt suportate în browserul tău.',
    [KEYS.NOTIFICATIONS_PUSH_PERMISSION_DENIED]: 'Permisiunea pentru notificări a fost refuzată. Activează-o din setările browserului.',
    [KEYS.NOTIFICATIONS_PUSH_ERROR]: 'Nu s-a putut actualiza preferința pentru notificări. Încearcă din nou.',
    [KEYS.NOTIFICATIONS_ERROR_LOAD]: 'Nu s-au putut încărca notificările. Încearcă din nou.',
    [KEYS.NOTIFICATIONS_CLEAR_READ]: 'Șterge citite',

    [KEYS.SUPPLIER_ADD_TITLE]: 'Adaugă furnizor',
    [KEYS.SUPPLIER_ADD_SUBTITLE]: 'Completează detaliile furnizorului',
    [KEYS.SUPPLIER_ADD_SUBMIT]: 'Adaugă furnizor',
    [KEYS.SUPPLIER_ADD_SUBMITTING]: 'Se adaugă...',
    [KEYS.SUPPLIER_ADD_ERROR]: 'Eroare la crearea furnizorului. Încearcă din nou.',
    [KEYS.SUPPLIER_EDIT_TITLE]: 'Editează furnizor',
    [KEYS.SUPPLIER_EDIT_SUBTITLE]: 'Actualizează detaliile furnizorului',
    [KEYS.SUPPLIER_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.SUPPLIER_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.SUPPLIER_EDIT_ERROR]: 'Eroare la actualizarea furnizorului. Încearcă din nou.',
    [KEYS.SUPPLIER_DELETE_TITLE]: 'Șterge furnizor',
    [KEYS.SUPPLIER_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.SUPPLIER_DELETE_BODY]: 'Toate datele asociate acestui furnizor vor fi șterse permanent.',
    [KEYS.SUPPLIER_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.SUPPLIER_DELETE_ERROR]: 'Eroare la ștergerea furnizorului. Încearcă din nou.',

    [KEYS.CREDENTIAL_ADD_TITLE]: 'Adaugă credențială',
    [KEYS.CREDENTIAL_ADD_SUBTITLE]: 'Salvează în siguranță datele de autentificare',
    [KEYS.CREDENTIAL_ADD_SUBMIT]: 'Adaugă credențială',
    [KEYS.CREDENTIAL_ADD_SUBMITTING]: 'Se adaugă...',
    [KEYS.CREDENTIAL_ADD_ERROR]: 'Eroare la crearea credențialei. Încearcă din nou.',
    [KEYS.CREDENTIAL_EDIT_TITLE]: 'Editează credențială',
    [KEYS.CREDENTIAL_EDIT_SUBTITLE]: 'Actualizează datele de autentificare',
    [KEYS.CREDENTIAL_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.CREDENTIAL_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.CREDENTIAL_EDIT_ERROR]: 'Eroare la actualizarea credențialei. Încearcă din nou.',
    [KEYS.CREDENTIAL_DELETE_TITLE]: 'Șterge credențială',
    [KEYS.CREDENTIAL_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.CREDENTIAL_DELETE_BODY]: 'Datele de autentificare stocate vor fi șterse permanent.',
    [KEYS.CREDENTIAL_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.CREDENTIAL_DELETE_ERROR]: 'Eroare la ștergerea credențialei. Încearcă din nou.',
    [KEYS.CREDENTIAL_VIEW_TITLE]: 'Vizualizează credențiala',
    [KEYS.CREDENTIAL_VIEW_USERNAME]: 'Utilizator',
    [KEYS.CREDENTIAL_VIEW_PASSWORD]: 'Parolă',
    [KEYS.CREDENTIAL_VIEW_COPY]: 'Copiază',
    [KEYS.CREDENTIAL_VIEW_COPIED]: 'Copiat!',
    [KEYS.CREDENTIAL_VIEW_AUTO_CLOSE]: 'Se închide în {n}s',
    [KEYS.CREDENTIAL_VIEW_NOTES]: 'Note',
    [KEYS.CREDENTIAL_WARNING_TITLE]: 'Avertisment de securitate',
    [KEYS.CREDENTIAL_WARNING_BODY]: 'Ești pe cale să vizualizezi credențiale sensibile. Asigură-te că nimeni nu îți vede ecranul.',
    [KEYS.CREDENTIAL_WARNING_CONFIRM]: 'Vizualizează credențialele',

    [KEYS.SERVICE_ADD_TITLE]: 'Adaugă serviciu',
    [KEYS.SERVICE_ADD_SUBTITLE]: 'Completează detaliile serviciului',
    [KEYS.SERVICE_ADD_SUBMIT]: 'Adaugă serviciu',
    [KEYS.SERVICE_ADD_SUBMITTING]: 'Se adaugă...',
    [KEYS.SERVICE_ADD_ERROR]: 'Eroare la crearea serviciului. Încearcă din nou.',
    [KEYS.SERVICE_ADD_TYPE_REQUIRED]: 'Tipul este obligatoriu',
    [KEYS.SERVICE_EDIT_TITLE]: 'Editează serviciu',
    [KEYS.SERVICE_EDIT_SUBTITLE]: 'Actualizează detaliile serviciului',
    [KEYS.SERVICE_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.SERVICE_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.SERVICE_EDIT_ERROR]: 'Eroare la actualizarea serviciului. Încearcă din nou.',
    [KEYS.SERVICE_DELETE_TITLE]: 'Șterge serviciu',
    [KEYS.SERVICE_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.SERVICE_DELETE_BODY]: 'Toate datele asociate acestui serviciu vor fi șterse permanent.',
    [KEYS.SERVICE_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.SERVICE_DELETE_ERROR]: 'Eroare la ștergerea serviciului. Încearcă din nou.',

    [KEYS.READING_ADD_TITLE]: 'Adaugă citire',
    [KEYS.READING_ADD_SUBMIT]: 'Adaugă citire',
    [KEYS.READING_ADD_SUBMITTING]: 'Se adaugă...',
    [KEYS.READING_ADD_ERROR]: 'Eroare la crearea citirii. Încearcă din nou.',
    [KEYS.READING_EDIT_TITLE]: 'Editează citire',
    [KEYS.READING_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.READING_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.READING_EDIT_ERROR]: 'Eroare la actualizarea citirii. Încearcă din nou.',
    [KEYS.READING_DELETE_TITLE]: 'Șterge citire',
    [KEYS.READING_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.READING_DELETE_BODY]: 'Această citire va fi ștearsă permanent.',
    [KEYS.READING_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.READING_DELETE_ERROR]: 'Eroare la ștergerea citirii. Încearcă din nou.',
    [KEYS.READING_VIEW_TITLE]: 'Detalii citire',
    [KEYS.READING_VIEW_READ_DATE]: 'Data citirii',
    [KEYS.READING_FIELD_FILE]: 'Fișier atașat',
    [KEYS.READING_FIELD_VALUE_REQUIRED]: 'Valoarea este obligatorie',
    [KEYS.READING_FIELD_DATE_REQUIRED]: 'Data citirii este obligatorie',

    [KEYS.READING_TEMPLATE_ADD_TITLE]: 'Adaugă șablon citire',
    [KEYS.READING_TEMPLATE_ADD_SUBMIT]: 'Adaugă șablon',
    [KEYS.READING_TEMPLATE_ADD_SUBMITTING]: 'Se adaugă...',
    [KEYS.READING_TEMPLATE_ADD_ERROR]: 'Eroare la crearea șablonului. Încearcă din nou.',
    [KEYS.READING_TEMPLATE_EDIT_TITLE]: 'Editează șablon citire',
    [KEYS.READING_TEMPLATE_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.READING_TEMPLATE_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.READING_TEMPLATE_EDIT_ERROR]: 'Eroare la actualizarea șablonului. Încearcă din nou.',
    [KEYS.READING_TEMPLATE_DELETE_TITLE]: 'Șterge șablon citire',
    [KEYS.READING_TEMPLATE_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.READING_TEMPLATE_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.READING_TEMPLATE_DELETE_ERROR]: 'Eroare la ștergerea șablonului. Încearcă din nou.',
    [KEYS.READING_TEMPLATE_FIELD_LABEL_REQUIRED]: 'Eticheta este obligatorie',

    [KEYS.REMINDER_ADD_TITLE]: 'Adaugă memento',
    [KEYS.REMINDER_ADD_SUBMIT]: 'Adaugă memento',
    [KEYS.REMINDER_ADD_SUBMITTING]: 'Se adaugă...',
    [KEYS.REMINDER_ADD_ERROR]: 'Eroare la crearea memento-ului. Încearcă din nou.',
    [KEYS.REMINDER_EDIT_TITLE]: 'Editează memento',
    [KEYS.REMINDER_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.REMINDER_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.REMINDER_EDIT_ERROR]: 'Eroare la actualizarea memento-ului. Încearcă din nou.',
    [KEYS.REMINDER_DELETE_TITLE]: 'Șterge memento',
    [KEYS.REMINDER_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.REMINDER_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.REMINDER_DELETE_ERROR]: 'Eroare la ștergerea memento-ului. Încearcă din nou.',
    [KEYS.REMINDER_VIEW_SUBTITLE]: 'Detalii memento',
    [KEYS.REMINDER_VIEW_ADVANCE]: 'Avansează',
    [KEYS.REMINDER_VIEW_ADVANCING]: 'Se avansează...',
    [KEYS.REMINDER_VIEW_ADVANCE_ERROR]: 'Eroare la avansarea memento-ului. Încearcă din nou.',
    [KEYS.REMINDER_FREQ_ONCE]: 'O dată',
    [KEYS.REMINDER_FREQ_DAILY]: 'Zilnic',
    [KEYS.REMINDER_FREQ_WEEKLY]: 'Săptămânal',
    [KEYS.REMINDER_FREQ_MONTHLY]: 'Lunar',
    [KEYS.REMINDER_FREQ_QUARTERLY]: 'Trimestrial',
    [KEYS.REMINDER_FREQ_YEARLY]: 'Anual',
    [KEYS.REMINDER_FIELD_TITLE_REQUIRED]: 'Titlul este obligatoriu',
    [KEYS.REMINDER_FIELD_DATE_REQUIRED]: 'Data scadentă este obligatorie',
    [KEYS.REMINDER_FIELD_FREQ_REQUIRED]: 'Frecvența este obligatorie',
    [KEYS.REMINDER_FIELD_IS_ACTIVE]: 'Activ',

    [KEYS.INVOICE_ADD_TITLE]: 'Adaugă factură',
    [KEYS.INVOICE_ADD_SUBTITLE]: 'Creează o factură nouă',
    [KEYS.INVOICE_ADD_SUBMIT]: 'Creează factură',
    [KEYS.INVOICE_ADD_SUBMITTING]: 'Se creează...',
    [KEYS.INVOICE_ADD_ERROR]: 'Eroare la crearea facturii. Încearcă din nou.',
    [KEYS.INVOICE_EDIT_TITLE]: 'Actualizează factură',
    [KEYS.INVOICE_EDIT_SUBMIT]: 'Actualizează factură',
    [KEYS.INVOICE_EDIT_SUBMITTING]: 'Se actualizează...',
    [KEYS.INVOICE_EDIT_ERROR]: 'Eroare la actualizarea facturii. Încearcă din nou.',
    [KEYS.INVOICE_DELETE_TITLE]: 'Șterge factură',
    [KEYS.INVOICE_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.INVOICE_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.INVOICE_DELETE_ERROR]: 'Eroare la ștergerea facturii. Încearcă din nou.',
    [KEYS.INVOICE_VIEW_TITLE]: 'Detalii factură',
    [KEYS.INVOICE_FIELD_SERVICE_REQUIRED]: 'Serviciul este obligatoriu',
    [KEYS.INVOICE_FIELD_LOADING_SERVICES]: 'Se încarcă serviciile...',
    [KEYS.INVOICE_FIELD_SELECT_SERVICE]: 'Selectează un serviciu',
    [KEYS.INVOICE_AMOUNT_ERROR]: 'Suma trebuie să fie 0 sau mai mare',
    [KEYS.INVOICE_DUE_DATE_ERROR]: 'Data scadentă trebuie să fie după data emiterii',
    [KEYS.INVOICE_PAID_DATE_ERROR]: 'Data plății trebuie să fie după data emiterii',

    [KEYS.INVOICE_TEMPLATE_ADD_TITLE]: 'Adaugă șablon factură',
    [KEYS.INVOICE_TEMPLATE_ADD_SUBTITLE]: 'Creează un model reutilizabil de factură',
    [KEYS.INVOICE_TEMPLATE_ADD_SUBMIT]: 'Adaugă șablon',
    [KEYS.INVOICE_TEMPLATE_ADD_SUBMITTING]: 'Se adaugă...',
    [KEYS.INVOICE_TEMPLATE_ADD_ERROR]: 'Eroare la crearea șablonului. Încearcă din nou.',
    [KEYS.INVOICE_TEMPLATE_EDIT_TITLE]: 'Editează șablon factură',
    [KEYS.INVOICE_TEMPLATE_EDIT_SUBTITLE]: 'Actualizează detaliile șablonului',
    [KEYS.INVOICE_TEMPLATE_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.INVOICE_TEMPLATE_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.INVOICE_TEMPLATE_EDIT_ERROR]: 'Eroare la actualizarea șablonului. Încearcă din nou.',
    [KEYS.INVOICE_TEMPLATE_DELETE_TITLE]: 'Șterge șablon factură',
    [KEYS.INVOICE_TEMPLATE_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.INVOICE_TEMPLATE_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.INVOICE_TEMPLATE_DELETE_ERROR]: 'Eroare la ștergerea șablonului. Încearcă din nou.',
    [KEYS.INVOICE_TEMPLATE_FIELD_LABEL_REQUIRED]: 'Eticheta este obligatorie',

    [KEYS.ACTION_ADD_TITLE]: 'Adaugă acțiune programată',
    [KEYS.ACTION_ADD_SUBTITLE]: 'Configurează crearea automată de facturi sau citiri',
    [KEYS.ACTION_ADD_SUBMIT]: 'Adaugă acțiune',
    [KEYS.ACTION_ADD_SUBMITTING]: 'Se adaugă...',
    [KEYS.ACTION_ADD_ERROR]: 'Eroare la crearea acțiunii. Încearcă din nou.',
    [KEYS.ACTION_EDIT_TITLE]: 'Editează acțiune programată',
    [KEYS.ACTION_EDIT_SUBTITLE]: 'Actualizează setările de automatizare',
    [KEYS.ACTION_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.ACTION_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.ACTION_EDIT_ERROR]: 'Eroare la actualizarea acțiunii. Încearcă din nou.',
    [KEYS.ACTION_DELETE_TITLE]: 'Șterge acțiunea programată',
    [KEYS.ACTION_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.ACTION_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.ACTION_DELETE_ERROR]: 'Eroare la ștergerea acțiunii. Încearcă din nou.',
    [KEYS.ACTION_RUNS_TITLE]: 'Rulări acțiune',
    [KEYS.ACTION_RUNS_SUBTITLE]: 'Istoricul execuțiilor automate',
    [KEYS.ACTION_FIELD_TYPE]: 'Tip acțiune',
    [KEYS.ACTION_FIELD_TYPE_REQUIRED]: 'Tipul acțiunii este obligatoriu',
    [KEYS.ACTION_FIELD_START_DATE]: 'Data de start',
    [KEYS.ACTION_FIELD_FREQUENCY]: 'Frecvență',
    [KEYS.ACTION_FIELD_FREQUENCY_REQUIRED]: 'Frecvența este obligatorie',
    [KEYS.ACTION_FIELD_NEXT_RUN_REQUIRED]: 'Data următoarei rulări este obligatorie',
    [KEYS.ACTION_FIELD_INVOICE_TEMPLATE_REQUIRED]: 'Șablonul de factură este obligatoriu',
    [KEYS.ACTION_FIELD_READING_TEMPLATE_REQUIRED]: 'Șablonul de citire este obligatoriu',
    [KEYS.ACTION_LOADING_TEMPLATES]: 'Se încarcă șabloanele...',
    [KEYS.ACTION_SELECT_TEMPLATE]: 'Selectează un șablon',
    [KEYS.ACTION_FIELD_IS_ACTIVE]: 'Activ',
    [KEYS.ACTION_RUNS_RAN_AT]: 'Rulat la',
    [KEYS.ACTION_RUNS_STATUS]: 'Status',
    [KEYS.ACTION_RUNS_RESULT]: 'Rezultat',
    [KEYS.ACTION_RUNS_ERROR]: 'Eroare',
    [KEYS.ACTION_RUNS_SUCCESS]: 'Succes',
    [KEYS.ACTION_RUNS_FAILED]: 'Eșuat',
    [KEYS.ACTION_RUNS_EMPTY]: 'Nu există rulări înregistrate pentru această acțiune.',

    [KEYS.EDIT_PROFILE_TITLE]: 'Editează profilul',
    [KEYS.EDIT_PROFILE_SUBTITLE]: 'Actualizează numele afișat',
    [KEYS.EDIT_PROFILE_SUBMIT]: 'Salvează',
    [KEYS.EDIT_PROFILE_SUBMITTING]: 'Se salvează...',
    [KEYS.EDIT_PROFILE_ERROR]: 'Eroare la actualizarea profilului. Încearcă din nou.',
    [KEYS.DELETE_ACCOUNT_TITLE]: 'Șterge contul',
    [KEYS.DELETE_ACCOUNT_SUBTITLE]: 'Această acțiune este permanentă și ireversibilă',
    [KEYS.DELETE_ACCOUNT_BODY]: 'Toate datele tale vor fi șterse permanent. Introdu parola pentru a confirma.',
    [KEYS.DELETE_ACCOUNT_PASSWORD_LABEL]: 'Parola ta',
    [KEYS.DELETE_ACCOUNT_SUBMIT]: 'Confirmă ștergerea',
    [KEYS.DELETE_ACCOUNT_SUBMITTING]: 'Se șterge...',
    [KEYS.DELETE_ACCOUNT_ERROR]: 'Eroare la ștergerea contului. Încearcă din nou.',
    [KEYS.EDIT_PROFILE_NAME_REQUIRED]: 'Numele este obligatoriu',
    [KEYS.DELETE_ACCOUNT_PASSWORD_REQUIRED]: 'Parola este obligatorie pentru ștergerea contului',
    [KEYS.DELETE_ACCOUNT_WARNING_TITLE]: 'Atenție: Acțiune permanentă',

    [KEYS.API_KEY_ADD_TITLE]: 'Adaugă cheie API',
    [KEYS.API_KEY_ADD_SUBTITLE]: 'Generează o nouă cheie API pentru integrări externe',
    [KEYS.API_KEY_ADD_SUBMIT]: 'Creează cheie API',
    [KEYS.API_KEY_ADD_SUBMITTING]: 'Se creează...',
    [KEYS.API_KEY_ADD_ERROR]: 'Eroare la crearea cheii API. Încearcă din nou.',
    [KEYS.API_KEY_EDIT_TITLE]: 'Editează cheie API',
    [KEYS.API_KEY_EDIT_SUBTITLE]: 'Actualizează setările cheii API',
    [KEYS.API_KEY_EDIT_SUBMIT]: 'Salvează modificările',
    [KEYS.API_KEY_EDIT_SUBMITTING]: 'Se salvează...',
    [KEYS.API_KEY_EDIT_ERROR]: 'Eroare la actualizarea cheii API. Încearcă din nou.',
    [KEYS.API_KEY_DELETE_TITLE]: 'Șterge cheie API',
    [KEYS.API_KEY_DELETE_SUBTITLE]: 'Aceasta va revoca imediat accesul',
    [KEYS.API_KEY_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.API_KEY_DELETE_ERROR]: 'Eroare la ștergerea cheii API. Încearcă din nou.',
    [KEYS.API_KEY_FIELD_EXPIRY]: 'Dată expirare',
    [KEYS.API_KEY_FIELD_EXPIRY_HINT]: 'Lasă necompletat pentru o cheie fără expirare.',
    [KEYS.API_KEY_FIELD_ABILITIES]: 'Permisiuni',
    [KEYS.API_KEY_FULL_ACCESS_LABEL]: 'Acces complet (*)',
    [KEYS.API_KEY_FULL_ACCESS_DESC]: 'Acordă acces la toate resursele și acțiunile',
    [KEYS.API_KEY_ABILITIES_REQUIRED]: 'Selectează cel puțin o permisiune sau folosește accesul complet',
    [KEYS.API_KEY_LOADING_ABILITIES]: 'Se încarcă permisiunile...',
    [KEYS.API_KEY_CREATED_TITLE]: 'Cheie API creată!',
    [KEYS.API_KEY_CREATED_BODY]: 'Copiază cheia acum. Nu o vei mai putea vedea.',
    [KEYS.API_KEY_CREATED_HINT]: 'Folosește această cheie în header-ul Authorization ca Bearer token.',
    [KEYS.API_KEY_REGEN_WARNING]: 'Regenerarea acestei chei va invalida imediat tokenul existent.',
    [KEYS.API_KEY_NAME_REQUIRED]: 'Numele este obligatoriu',
    [KEYS.API_KEY_FIELD_EXPIRY_OPTIONAL]: '— opțional',
    [KEYS.API_KEY_FIELD_EXPIRY_REMOVE_HINT]: 'Lasă necompletat pentru a elimina data de expirare.',
    [KEYS.API_KEY_CREATED_TOKEN_LABEL]: 'Tokenul tău API',
    [KEYS.API_KEY_DELETE_BODY]: 'Orice aplicație care folosește acest token va pierde imediat accesul. Aceasta nu poate fi anulată.',

    [KEYS.INVITE_CODE_DELETE_TITLE]: 'Șterge cod de invitație',
    [KEYS.INVITE_CODE_DELETE_SUBTITLE]: 'Această acțiune nu poate fi anulată',
    [KEYS.INVITE_CODE_DELETE_BODY]: 'Acest cod de invitație va fi șters permanent.',
    [KEYS.INVITE_CODE_DELETE_BODY_USED]: 'Acest cod a fost deja utilizat și va fi șters permanent.',
    [KEYS.INVITE_CODE_DELETE_SUBMITTING]: 'Se șterge...',
    [KEYS.INVITE_CODE_DELETE_ERROR]: 'Eroare la ștergerea codului. Încearcă din nou.',
    [KEYS.INVITE_CODE_CREATED_TITLE]: 'Cod de invitație creat!',
    [KEYS.INVITE_CODE_CREATED_BODY]: 'Copiază codul acum. Nu îl vei mai putea vedea.',
    [KEYS.INVITE_CODE_DELETE_BODY_UNUSED]: 'Acest cod nu a fost utilizat încă. Ștergerea lui va împiedica înregistrarea cu el.',
    [KEYS.INVITE_CODE_CREATED_LABEL]: 'Cod de invitație',

    [KEYS.COMMON_NAME]: 'Nume',
    [KEYS.COMMON_BACK]: 'Înapoi',
    [KEYS.COMMON_LOADING]: 'Se încarcă...',
    [KEYS.COMMON_BACK_TO_LOGIN]: 'Înapoi la autentificare',
    [KEYS.COMMON_ERROR_GENERIC]: 'Ceva nu a mers bine. Te rugăm să încerci din nou.',
    [KEYS.COMMON_NEVER]: 'Niciodată',
    [KEYS.COMMON_CANCEL]: 'Anulează',
    [KEYS.COMMON_SAVE]: 'Salvează',
    [KEYS.COMMON_CLOSE]: 'Închide',
    [KEYS.COMMON_CONFIRM]: 'Confirmă',
    [KEYS.COMMON_DELETE]: 'Șterge',
    [KEYS.COMMON_EDIT]: 'Editează',
    [KEYS.COMMON_ADD]: 'Adaugă',
    [KEYS.COMMON_RETRY]: 'Încearcă din nou',
    [KEYS.COMMON_VIEW]: 'Vizualizează',

    [KEYS.LOGIN_TAGLINE]: 'Autentifică-te în contul tău',
    [KEYS.LOGIN_FORGOT_PASSWORD]: 'Ai uitat parola?',
    [KEYS.LOGIN_SUBMIT]: 'Autentificare',
    [KEYS.LOGIN_SUBMITTING]: 'Se autentifică...',
    [KEYS.LOGIN_NO_ACCOUNT]: 'Nu ai un cont?',
    [KEYS.LOGIN_CREATE_ONE]: 'Creează unul',
    [KEYS.LOGIN_RESET_SUCCESS]: 'Parola ta a fost resetată. Autentifică-te mai jos.',
    [KEYS.LOGIN_ERROR_GENERIC]: 'A apărut o eroare la autentificare',    
    [KEYS.LOGIN_REMEMBER_ME]: 'Ține-mă minte',
    [KEYS.REGISTER_TAGLINE_INVITE]: 'Introdu codul de invitație',
    [KEYS.REGISTER_TAGLINE_FORM]: 'Creează-ți contul',
    [KEYS.REGISTER_INVITE_CODE]: 'Cod de invitație',
    [KEYS.REGISTER_INVITE_PLACEHOLDER]: 'Lipește codul de invitație aici',
    [KEYS.REGISTER_CONTINUE]: 'Continuă',
    [KEYS.REGISTER_CONTINUING]: 'Se verifică...',
    [KEYS.REGISTER_CONFIRM_PASSWORD]: 'Confirmă parola',
    [KEYS.REGISTER_SUBMIT]: 'Creează cont',
    [KEYS.REGISTER_SUBMITTING]: 'Se creează contul...',
    [KEYS.REGISTER_ALREADY_ACCOUNT]: 'Ai deja un cont?',
    [KEYS.REGISTER_SIGN_IN]: 'Autentifică-te',
    [KEYS.REGISTER_ERROR_INVITE_REQUIRED]: 'Te rugăm să introduci un cod de invitație',
    [KEYS.REGISTER_ERROR_PASSWORDS_MISMATCH]: 'Parolele nu coincid',
    [KEYS.REGISTER_ERROR_GENERIC]: 'A apărut o eroare la înregistrare',

    [KEYS.NAV_DASHBOARD]: 'Panou principal',
    [KEYS.NAV_SUPPLIERS]: 'Furnizori',
    [KEYS.NAV_SERVICES]: 'Servicii',
    [KEYS.NAV_INVOICES]: 'Facturi',
    [KEYS.NAV_PROFILE]: 'Profil',
    [KEYS.NAV_REMINDERS]: 'Memento-uri',
    [KEYS.NAV_NOTIFICATIONS]: 'Notificări',
    [KEYS.NAV_API_KEYS]: 'Chei API',
    [KEYS.NAV_SECTION_MAIN]: 'PRINCIPAL',
    [KEYS.NAV_SECTION_MANAGEMENT]: 'MANAGEMENT',
    [KEYS.NAV_LOGOUT]: 'Ieșire',
    [KEYS.LAYOUT_VERIFY_EMAIL]: 'Te rugăm să îți verifici adresa de email.',
    [KEYS.LAYOUT_VERIFY_EMAIL_SENT]: 'Email de verificare trimis!',
    [KEYS.LAYOUT_VERIFY_EMAIL_ALREADY]: 'Emailul tău este deja verificat — încearcă să reîncarci pagina.',
    [KEYS.LAYOUT_VERIFY_EMAIL_RESEND]: 'Retrimite emailul',
    [KEYS.LAYOUT_VERIFY_EMAIL_RESENDING]: 'Se trimite...',

    [KEYS.FORGOT_PASSWORD_TAGLINE]: 'Resetează parola',
    [KEYS.FORGOT_PASSWORD_DESCRIPTION]: 'Introdu adresa de email și îți vom trimite un link pentru resetarea parolei.',
    [KEYS.FORGOT_PASSWORD_SUBMIT]: 'Trimite link de resetare',
    [KEYS.FORGOT_PASSWORD_SUBMITTING]: 'Se trimite...',
    [KEYS.FORGOT_PASSWORD_SENT]: 'Verifică-ți căsuța — am trimis un link de resetare a parolei la {email}.',
    [KEYS.FORGOT_PASSWORD_CHECK_SPAM]: 'Nu l-ai primit? Verifică folderul spam sau',
    [KEYS.FORGOT_PASSWORD_TRY_AGAIN]: 'încearcă din nou',

    [KEYS.RESET_PASSWORD_TAGLINE]: 'Alege o nouă parolă',
    [KEYS.RESET_PASSWORD_NEW_PASSWORD]: 'Parolă nouă',
    [KEYS.RESET_PASSWORD_CONFIRM_PASSWORD]: 'Confirmă parola',
    [KEYS.RESET_PASSWORD_SUBMIT]: 'Resetează parola',
    [KEYS.RESET_PASSWORD_SUBMITTING]: 'Se resetează...',
    [KEYS.RESET_PASSWORD_ERROR_PASSWORDS_MISMATCH]: 'Parolele nu coincid.',
};

export default ro;
